import { APP_STORE_URL } from '../../constants/event'

export function AppStoreButton() {
  return (
    <button
      type="button"
      onClick={(e) => {
        // Stop the card's onClick from also firing (which would expand the
        // wallet) and navigate explicitly. Native <a> + target=_blank inside
        // the active card's body was getting eaten by Safari's click handling.
        e.stopPropagation()
        window.location.href = APP_STORE_URL
      }}
      className="inline-flex items-center justify-center bg-transparent p-0 transition-transform active:scale-[0.98]"
      aria-label="Download on the App Store"
    >
      <img
        src="/Download_on_the_App_Store_Badge.svg"
        alt="Download on the App Store"
        className="pointer-events-none h-[46px] w-auto"
        draggable={false}
      />
    </button>
  )
}
